export default __webpack_public_path__ + "static/media/gmarket-demo.a6f4c010.gif";